<template>
  <div class="download-report-page">
    <div class="report-page seller-detail-pdf">
      <div class="pdfpage">
        <ReportHeader :brandname="brandname" :report="$t('DashboardProduct.tablinkseller')" />
        <PDFSellerDetail :details="details" />
        <div class="pdfpage-body-row-header">
          <h2>{{ $t('Seller.t15') }}({{ totalproducts }})</h2>
        </div>        
        <PDFSellerProductTable :tabledata="tableDataProduct" />
        <p v-if="totalproducts > 6" class="moredatalist">更多数据请登录 BPS 平台查看</p>
        <ReportFooter :update="update" :year="year" :page="1" :total="totalsellers > 0 ? 2 : 1" :height="footerheight" />
      </div><!-- 第一页 -->

      <div class="pdfpage" v-if="totalsellers > 0">
        <ReportHeader :brandname="brandname" :report="$t('DashboardProduct.tablinkseller')" />
        <div class="pdfpage-body-row-header">
          <h2>{{ $t('Seller.t10') }}({{ totalsellers }})</h2>
        </div>        
        <PDFSellerRelateTable :tabledata="tableDataSeller" :showecommerce="showecommerce" />
        <p v-if="tableDataSeller > 6" class="moredatalist">更多数据请登录 BPS 平台查看</p>
        <ReportFooter :update="update" :year="year" :page="2" :total="2" :height="footerheight" />
      </div><!-- 第二页 -->

    </div><!--report-page-->
  </div>
</template>

<script>
import ReportHeader from '@/components/Commons/Header.vue'
import ReportFooter from '@/components/Commons/Footer.vue'
import PDFSellerDetail from '@/components/Seller/DownloadPDF/PDFSellerDetail.vue'
import PDFSellerProductTable from '@/components/Seller/DownloadPDF/PDFSellerProductTable.vue'
import PDFSellerRelateTable from '@/components/Seller/DownloadPDF/PDFSellerRelateTable.vue'
export default {
  components:{
    ReportHeader,
    ReportFooter,
    PDFSellerDetail,
    PDFSellerProductTable,
    PDFSellerRelateTable
  },
  data(){
    return{
      brandname: '',
      subid: this.$route.params.SubId,
      shopid: this.$route.params.ShopId,
      lan: this.$route.params.Lan,
      footerheight: this.$route.params.Lan === 'zh' ? 180 : 240,
      update: '',
      year: '',
      details: {},
      tableDataProduct: [],
      tableDataSeller: [],
      totalproducts: 0,
      totalsellers: 0,
      showecommerce: false
    }
  },

  mounted(){
    this.year = this.$moment(new Date()).format('YYYY')
    this.$i18n.locale = this.lan
    this.getDetails()
    this.getSellerProducts()
    this.getCount()
  },

  methods: {

    /**
     * 重置数据列表
     */
    setTableList: function(lists){

    },
    
    /**
     * 店铺详情
     */
    getDetails: function(){
      let that = this
      let url = that.API_URL 
                + '/v3/price/shop/detailInfo?shopid=' 
                + that.shopid
                + '&subid=' 
                + that.subid;
      $.ajax({
        url: url,
        type: "GET",
        changeOrigin: true,
        dataType: "json",
        contentType: "application/json",
        success: function(rex) {
          let shopdetail = rex.results[0][0]
          console.log('shopdetail', shopdetail)
          shopdetail.logoimg = that.setChannel(shopdetail.channelName).src
          shopdetail.update = that.$moment(rex.results[1][0].createTime).local().format('YYYY-MM-DD HH:mm')
          shopdetail.isYjdf = shopdetail.isYjdf/1 === 0 ? that.$t('dsfx.t53') : that.$t('dsfx.t52')
          shopdetail.isAuth = shopdetail.isAuth/1 === 0 ? that.$t('dsfx.t53') : that.$t('dsfx.t52')
          shopdetail.shopLab = shopdetail.shopLab/1 === 0 ? that.$t('dsfx.t53') : that.$t('dsfx.t52')
          shopdetail.shopLevel = shopdetail.shopLevel === '' || shopdetail.shopLevel === null ? 5 : shopdetail.shopLevel*1
          shopdetail.channelLevel = shopdetail.channelLevel === '' || shopdetail.channelLevel === null ? 5 : shopdetail.channelLevel*1
          shopdetail.weiXin = shopdetail.weiXin == '无数据' ? '' : shopdetail.weiXin
          shopdetail.weibo = shopdetail.weibo == '无数据' ? '' : shopdetail.weibo
          shopdetail.mobile = shopdetail.mobile == '无数据' ? '' : shopdetail.mobile
          shopdetail.tsTime = shopdetail.tsTime == null ? '' : that.$moment(shopdetail.tsTime).utc().format('YYYY-MM-DD HH:mm')
          that.details = shopdetail
          that.update = that.$moment(rex.results[1][0].createTime).local().format('YYYY-MM-DD HH:mm')
        },
        error: function(response) {
          console.log('getDetails', response)
        }
      })
    },

		/**
		 * 获取低价链接
		 */
		getSellerProducts: function(){
      let that = this
			let url = that.API_URL + '/v3/price/statistics/paging'
			let query ={
        project: that.subid,
        shopid: that.shopid,
        page: 1,
        size: 6,
        order: 50
			}
      $.ajax({
        url: url,
        type: "GET",
        changeOrigin: true,
        dataType: "json",
        contentType: "application/json",
        data: query,
        success: function(rex) {
					console.log('getSellerProducts', rex)
					let data = rex.results[1]
          let getNow = that.$moment(new Date()).utc(8)
					data.forEach(item => {
            item.AssetIdIcon = that.chkCrawltime(item.crawltime, getNow) ? item.AssetId + ' <i class="icon-newdata-txt">New</i>' : item.AssetId
            item.jiamao = that.checkfakeicons('明显假冒', item.itemlab)
            item.shangbiao = that.checkfakeicons('滥用商标词', item.itemlab)
            item.daotu = that.checkfakeicons('盗图', item.itemlab)
						item.ChannelIcon = that.setChannel(item.Channel).src
            item.authorize = item.IsAuthor/1 === 0 ? that.$t('dsfx.t53') : that.$t('dsfx.t52')
            item.MarginPercent = (item.MarginPercent * 100).toFixed(2) + "%"
            item.SkuTotalAmountStr = item.Channel == '拼多多' || item.Channel == '微店' ? 
                                      that.setPriorityLevel(item.TotalAmount, 0) : 
                                      that.setPriorityLevel(item.TotalAmount, 1)
					})
					that.totalproducts = rex.results[0][0].Count
					that.tableDataProduct = data
        },
        error: function(response) {
          console.log('getSellerProducts', response)
        }
			})
		},

    /**
     * 获取关联卖家数
     */
    getCount: function () {
      let that = this
      let url = this.API_URL + '/v3/price/shop/getCount?shopId=' + this.shopid + '&subid=' + this.subid;
      $.ajax({
        url:  url,
        type: "GET",
        changeOrigin: true,
        crossDomain: true,
        success: function(rex) {
          console.log('tableviewModelChange',rex)
          that.totalsellers = rex.results.count
          if(that.totalsellers > 0){
            that.getSellerShops()
          }
        },
        error: function(response) {
          console.log(response)
        }
      });
    },

    /**
     * 获取卖家关联店铺
     */
    getSellerShops: function () {
      let that = this
      let newQuery = {
        shopId: that.shopid,
        subid: that.subid,
        page: 1,
        order: 50,
        size: 6
      };
      let url = this.API_URL + '/v3/price/shop/paging';
      $.ajax({
        url:  url,
        type: "GET",
        data: newQuery,
        changeOrigin: true,
        crossDomain: true,
        success: function(rex) {
          console.log('getSellerShops',rex)
          let data = rex.results[1]
          data.forEach(
            item => {
              item.ChannelName = that.setChannel(item.Channel).src
              item.Authorize = item.IsAuthor/1
              item.AuthorizeText = item.IsAuthor/1 ===  0 ? that.$t('dsfx.t53') : that.$t('dsfx.t52')
              item.isQinqText = item.isQinq/1 ===  0 ? that.$t('dsfx.t53') : that.$t('dsfx.t52')
              item.FakeSku = item.FakeItem
              item.Discriminant = item.ReportLink
              item.RightsProtectionStartTime = item.RightsProtectionTime != "" ? that.$moment(item.RightsProtectionTime).utc().local().format('YYYY-MM-DD HH:mm:ss') : item.RightsProtectionTime
              item.ResultId = item.ShopId
              item.Discount = (item.Discount * 100).toFixed(2) + "%"
              item.ShopLab = item.ShopLab === null ? '' : item.ShopLab === '跨境' ? that.$t('Seller.t8') : that.$t('Seller.t9')
              item.SkuTotalAmountStr = item.Channel == '拼多多' || item.Channel == '微店' ? that.$t('jgjk.s245') + that.formartAmount(item.SkuTotalAmount) : that.$t('jgjk.s246') + that.formartAmount(item.SkuTotalAmount)
              item.label = item.label/1 === 0 || item.label == null ? 1 : item.label/1
              item.shoplevel = item.shoplevel == null || item.shoplevel == '' ? 5 : item.shoplevel/1
            }
          )
          that.tableDataSeller = data
        },
        error: function(response) {
          console.log(response)
        }
      });
    },

    /**
     * 判断是否一天内
     * 显示New ICON图标
     */
    chkCrawltime: function(ctime, ntime){
      if(ctime){
        if(this.$moment(ntime).diff(this.$moment(ctime),'hours') < 24){
          return true
        }else{
          return false
        }
      }else{
        return false
      }
    },

  }

}
</script>